
const ComputeHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Compute Resources
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Compute page provides a comprehensive view of your AWS compute resources including EC2 instances,
          Lambda functions, ECS/EKS containers, and other compute services. Monitor performance, track costs,
          and optimize resource utilization across your infrastructure.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          EC2 Instance Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor and manage your EC2 instances across all regions and accounts.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Instance Inventory:</strong> Complete list of all EC2 instances with details</li>
          <li><strong>State Monitoring:</strong> Track running, stopped, and terminated instances</li>
          <li><strong>Instance Types:</strong> View distribution of instance families and sizes</li>
          <li><strong>Utilization Metrics:</strong> CPU, memory, network, and disk usage</li>
          <li><strong>Cost Analysis:</strong> Per-instance cost tracking and optimization opportunities</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Serverless Compute
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track AWS Lambda functions and serverless application performance.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Function Inventory:</strong> All Lambda functions across your environments</li>
          <li><strong>Invocation Metrics:</strong> Execution count, duration, and error rates</li>
          <li><strong>Cost per Function:</strong> Detailed cost breakdown for each Lambda function</li>
          <li><strong>Memory Optimization:</strong> Right-size memory allocations for cost efficiency</li>
          <li><strong>Cold Start Analysis:</strong> Identify and reduce cold start latencies</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Container Services
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor ECS, EKS, and containerized workloads.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>ECS Clusters:</strong> Track ECS tasks, services, and container instances</li>
          <li><strong>EKS Clusters:</strong> Monitor Kubernetes clusters and node groups</li>
          <li><strong>Container Metrics:</strong> CPU, memory, and network usage per container</li>
          <li><strong>Fargate vs EC2:</strong> Compare costs and performance across launch types</li>
          <li><strong>Auto-Scaling:</strong> Monitor scaling policies and capacity</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Performance Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track compute resource performance and identify bottlenecks.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>CPU Utilization:</strong> Average and peak CPU usage across resources</li>
          <li><strong>Memory Usage:</strong> Memory consumption patterns and spikes</li>
          <li><strong>Network Performance:</strong> Bandwidth usage and network latency</li>
          <li><strong>Disk I/O:</strong> Storage read/write operations and throughput</li>
          <li><strong>Performance Alerts:</strong> Notifications for resource constraints</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Resource Optimization
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Identify and implement compute optimization opportunities.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Underutilized Instances:</strong> Resources with consistently low usage</li>
          <li><strong>Right-Sizing:</strong> Recommendations for optimal instance sizes</li>
          <li><strong>Purchasing Options:</strong> Savings Plans and Reserved Instance opportunities</li>
          <li><strong>Spot Instance Usage:</strong> Potential for Spot instances in workloads</li>
          <li><strong>Auto-Scaling Tuning:</strong> Optimize scaling policies for cost and performance</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Tracking
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor compute costs and identify spending trends.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Service Breakdown:</strong> Costs by EC2, Lambda, ECS, EKS, etc.</li>
          <li><strong>Instance Type Costs:</strong> Spending distribution across instance families</li>
          <li><strong>Region Costs:</strong> Geographic distribution of compute spending</li>
          <li><strong>Cost Trends:</strong> Daily, weekly, and monthly spending patterns</li>
          <li><strong>Budget Tracking:</strong> Compute spending vs. allocated budgets</li>
        </ul>
      </div>

    </>
  );
};

export default ComputeHelp;
